<template>
  <div class="switch" @click="$emit('click', !selected);">
    <input type="checkbox" v-bind:checked="selected" />
    <span class="slider round"></span>
    <span v-if="selected" class="on-text">{{onText}}</span>
    <span v-else class="off-text">{{offText}}</span>
  </div>
</template>

<script>
export default {
  name: 'SliderSwitch',
  props: {
    selected: Boolean,
    onText: {
      type: String,
      default: 'On',
    },
    offText: {
      type: String,
      default: 'Off',
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 64px;
  height: 28px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 24px;
  width: 24px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
  box-shadow: 1px 1px 5px #888888;
}

input:checked + .slider {
  background-color: #51b847;
}

input:focus + .slider {
  box-shadow: 0 0 1px #51b847;
}

input:checked + .slider:before {
  transform: translateX(36px);
  box-shadow: -1px -1px 5px #8080809c;
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
  cursor: pointer;
}

.slider.round:before {
  border-radius: 50%;
}

.on-text {
  position: relative;
  left: 8px;
  top: 1px;
  color: white;
  user-select: none;
  transition: 0.4s;
  font-variant: all-small-caps;
}

.off-text {
  position: relative;
  left: 30px;
  top: 1px;
  color: white;
  user-select: none;
  transition: 0.4s;
  font-variant: all-small-caps;
}
</style>
